import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isNullEmpty'
})
export class IsNullEmptyPipe implements PipeTransform {

  /**
   * Pipe que valida un string no este vacío, nulo o undefined
   * @param value es el string que se va a validar si cumple el requisito
   * @returns true o false si cumple con la regla
   */
  transform = (value: string) => !(typeof value === 'string' && value.length > 0);

}
